import React from "react";
import StdPreviousEducation from "../../components/StudentTabs/StudentPreviousEducation/StdPreviousEducation"

const Education= () => {
  return (
    <div>
      
      <StdPreviousEducation/>
    </div>
  );
};

export default Education;